export default "__VITE_PUBLIC_ASSET__eb5abde8__"